var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.showDashboard)?_c('dashboard-core-app-bar'):_vm._e(),(!_vm.showHome)?_c('dashboard-core-drawer'):_vm._e(),_c('dashboard-core-view'),(_vm.showHome)?_c('dashboard-core-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }